import * as React from 'react';
import { useQuery } from '@tanstack/react-query';

import { Events } from '@graylog/server-api';

import { Spinner } from 'components/common';
import { Button } from 'components/bootstrap';
import { Modal } from 'security-app/components/common/Modal';
import BulkEventReplay from 'components/events/bulk-replay/BulkEventReplay';
import RemainingBulkActions from 'components/events/bulk-replay/RemainingBulkActions';
import { useModalContext } from 'common/contexts';
import type { SecurityEventAPIType } from 'security-app/hooks/api/securityEventsAPI.types';

const useEventsById = (eventIds: Array<string>) =>
  useQuery(['events', eventIds], () => Events.getByIds({ event_ids: eventIds }));

function BulkReplayEvent() {
  const { entity: securityEvents, setEntity, setModal } = useModalContext();
  const initialEventIds = securityEvents?.map((secEvent: SecurityEventAPIType) => secEvent.event_id);
  const { data: events, isInitialLoading } = useEventsById(initialEventIds);

  const onClose = React.useCallback(() => {
    setModal(null);
    setEntity(null);
  }, [setEntity, setModal]);

  return (
    <Modal
      show
      maxWidth="2000px"
      title="Replay Events"
      onClose={onClose}
      closeOnBackdrop
      buttons={
        <Button bsStyle="primary" onClick={onClose}>
          Close
        </Button>
      }>
      {isInitialLoading ? (
        <Spinner text="Loading Events" />
      ) : (
        <BulkEventReplay
          events={events}
          initialEventIds={initialEventIds}
          onClose={onClose}
          BulkActions={RemainingBulkActions}
        />
      )}
    </Modal>
  );
}

export default BulkReplayEvent;
